import { Component } from '@ribajs/core'
import { isInMarketAllowlist } from '../utils'

/**
 * A blog component contains blog articles
 */
export class SbBlogComponent extends Component {
  public static tagName = 'sb-blog'

  public scope = {
    allowedMarkets: [] as string[],
  }

  static get observedAttributes(): string[] {
    return ['allowed-markets']
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbBlogComponent.observedAttributes)
  }

  async beforeBind() {
    // Remove the blog if the current market is not in the allowlist
    if (!isInMarketAllowlist(this.scope.allowedMarkets)) {
      this.remove()
    }
    await super.beforeBind()
  }

  protected template() {
    return null
  }
}
